/* eslint-disable react/no-array-index-key */
import {
  BitkitButton,
  BitkitCheckbox,
  BitkitIconButton,
  BitkitTextInput,
  BitkitTooltip,
  IconDollar,
  IconInfoCircle,
  IconPlusCircle,
  IconTrash,
} from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';
import { Controller, useFieldArray, UseFieldArrayReturn, useFormContext } from 'react-hook-form';

import { BuildEnvironment } from '../../../../../models/TriggerParams';
import FormBlock from '../FormBlock/FormBlock';
import { BuildConfigurationType } from '../types';

export interface CustomVarsProps {
  isLastItem?: boolean;
}

interface InputGroupProps {
  index: number;
  remove: UseFieldArrayReturn<BuildConfigurationType>['remove'];
}

const InputGroup = (props: InputGroupProps) => {
  const { remove, index } = props;
  const { control } = useFormContext<BuildConfigurationType>();

  return (
    <div>
      <Box display="flex" marginBlockEnd="12" gap="16">
        <Controller
          render={({ field }) => (
            <BitkitTextInput
              flex={1}
              inputProps={field}
              label="Key"
              labelHidden
              optional
              placeholder="KEY"
              startElement={<IconDollar />}
            />
          )}
          name={`${'environments'}.${index}.key`}
          control={control}
        />
        <Controller
          render={({ field }) => (
            <BitkitTextInput flex={1} inputProps={field} label="Value" labelHidden optional placeholder="VALUE" />
          )}
          name={`${'environments'}.${index}.value`}
          control={control}
        />
        <BitkitIconButton icon={IconTrash} label="Remove" variant="secondary" onClick={() => remove(index)} />
      </Box>
      <Controller
        render={({ field: { name, onBlur, onChange, ref, value } }) => (
          <BitkitCheckbox
            checked={value}
            inputProps={{ onBlur }}
            labelText={
              <>
                Replace variables in input{' '}
                <BitkitTooltip text="Enable this if you want to replace Environment Variables in your input with the variable's assigned value.">
                  <IconInfoCircle size="16" tabIndex={0} />
                </BitkitTooltip>
              </>
            }
            name={name}
            onCheckedChange={({ checked }) => onChange(checked === true)}
            ref={ref}
          />
        )}
        name={`environments.${index}.isExpand`}
        control={control}
      />
    </div>
  );
};

const CustomVars = (props: CustomVarsProps) => {
  const { isLastItem } = props;
  const { control } = useFormContext<BuildConfigurationType>();

  const { append, fields, remove } = useFieldArray({
    control,
    name: 'environments',
  });

  return (
    <FormBlock isLastItem={isLastItem} title="Custom Environment Variables">
      {fields.map((item, index) => {
        return <InputGroup index={index} key={item.key + index} remove={remove} />;
      })}
      <BitkitButton
        icon={IconPlusCircle}
        variant="secondary"
        width="100%"
        onClick={() => {
          const appendObject: BuildEnvironment = { isExpand: true, key: '', value: '' };
          append(appendObject);
        }}
      >
        Add a custom Env Var
      </BitkitButton>
    </FormBlock>
  );
};

export default CustomVars;
